import React from 'react';
import './expandableText.scss';
import InlineEditableElement from 'Components/InlineEditableElement';
import _ from 'underscore';

function expandableTextHoc(Component) {
  return class ExpandableTextHoc extends React.Component {
    constructor() {
      super(...arguments);
      this.state = {
        openedItems: [],
        hoveredItem: -1
      };
      this.headingClicked = this.headingClicked.bind(this);
      this.mouseEnteredHeading = this.mouseEnteredHeading.bind(this);
      this.mouseLeftHeading = this.mouseLeftHeading.bind(this);
      this.itemTextChanged = this.itemTextChanged.bind(this);
      this.itemHeadingChanged = this.itemHeadingChanged.bind(this);
      this.fontFamilyChanged = this.fontFamilyChanged.bind(this);
    }

    componentDidMount() {
      this.props.section.on(
        'change',
        () => {
          this.forceUpdate();
        },
        this
      );
    }

    fontFamilyChanged(fonts) {
      let extantFonts = this.props.section.prop('fonts') || [];
      extantFonts.forEach(font => {
        fonts.push(font);
      });
      let uniqueFamilies = [];
      $.each(fonts, function(i, el) {
        if ($.inArray(el, uniqueFamilies) === -1) uniqueFamilies.push(el);
      });
      uniqueFamilies.sort((a, b) => {
        return a > b;
      });
      if (uniqueFamilies.join(',') !== extantFonts.join(',')) {
        this.props.section.prop('fonts', uniqueFamilies);
        FW.store.get('page').getFonts();
      }
    }

    componentWillUnmount() {
      this.props.section.off(null, null, this);
    }

    itemHeadingChanged(itemIndex, value) {
      let items = _.clone(this.props.section.prop('items'));
      items[itemIndex].heading = value;
      this.props.section.prop('items', items);
    }

    itemTextChanged(itemIndex, value) {
      let items = _.clone(this.props.section.prop('items'));
      items[itemIndex].text = value;
      this.props.section.prop('items', items);
    }

    headingClicked(itemIndex) {
      let openedItems = _.clone(this.state.openedItems);
      const newValue = !openedItems[itemIndex];
      if (
        !this.props.section.prop('expandable_text_options').allow_multiple_open
      )
        openedItems = [];
      openedItems[itemIndex] = newValue;
      this.setState({
        openedItems: openedItems
      });
    }

    mouseEnteredHeading(itemIndex) {
      this.setState({
        hoveredItem: itemIndex
      });
    }

    mouseLeftHeading(itemIndex) {
      if (this.state.hoveredItem === itemIndex)
        this.setState({
          hoveredItem: -1
        });
    }

    render() {
      let props = _.clone(this.props);
      props.itemHeadingChanged = this.itemHeadingChanged;
      props.itemTextChanged = this.itemTextChanged;
      props.chooseNearest = this.chooseNearest;
      props.filesFetched = this.filesFetched;
      props.openedItems = this.state.openedItems;
      props.hoveredItem = this.state.hoveredItem;
      props.mouseLeftHeading = this.mouseLeftHeading;
      props.mouseEnteredHeading = this.mouseEnteredHeading;
      props.headingClicked = this.headingClicked;
      props.fontFamilyChanged = this.fontFamilyChanged;
      return <Component {...props} />;
    }
  };
}

class ExpandableText extends React.Component {
  render() {
    const section = this.props.section;
    const options = section.prop('expandable_text_options');
    const headingBkg = options.heading_background_color;
    const headingHoverBkg = options.heading_hover_background_color;
    const headingOpenedBkg = options.heading_opened_background_color;
    const textBkg = options.text_background_color;
    const fontSize = section.prop('font_size')
      ? section.prop('font_size').size
      : 22 || 22;
    const HeadingType = section.prop('heading_element_type') || 'h3';
    let items = section.prop('items').map((item, i) => {
      const opened = this.props.openedItems[i];
      const hovered = this.props.hoveredItem === i;
      const headingBackgroundColor = hovered
        ? headingHoverBkg
        : opened
        ? headingOpenedBkg
        : headingBkg;
      return (
        <div
          key={`item-${i}`}
          id={`item-${i}`}
          className={section.prop('expandable_text_style') + ' col-md-12'}
        >
          <div
            className={'expandableTextHeading'}
            style={{background: headingBackgroundColor}}
            onClick={this.props.headingClicked.bind(this, i)}
            onMouseEnter={this.props.mouseEnteredHeading.bind(this, i)}
            onMouseLeave={this.props.mouseLeftHeading.bind(this, i)}
          >
            <i className={'prefixIcon fa fa-info primaryBackground'} />
            <HeadingType style={{fontSize: fontSize}} className={'heading'}>
              {item.heading}
            </HeadingType>
            <div className={'expandButton primaryBackground'}>
              <i
                className={
                  'expandIcon ' + (opened ? 'fa fa-minus' : 'fa fa-plus')
                }
              />
            </div>
            <i className={'fa ' + (opened ? 'fa-caret-up' : 'fa-caret-down')} />
          </div>
          <div
            className={'expandableTextText'}
            style={{background: textBkg, display: opened ? 'block' : 'none'}}
          >
            <InlineEditableElement
              fontFamilyChanged={this.props.fontFamilyChanged.bind(this)}
              html={item.text}
              onChange={this.props.itemTextChanged.bind(this, i)}
              enter={0} // P
              inlineEditingEnabled={this.props.inlineEditingEnabled}
            />
          </div>
        </div>
      );
    });
    return (
      <div
        id={'expandableTextSection-' + section.get('id')}
        className="expandableTextSection col-md-12"
        style={{padding: 0, margin: 0}}
      >
        {items}
      </div>
    );
  }
}

export {expandableTextHoc as hoc};
export default expandableTextHoc(ExpandableText);
